// extracted by mini-css-extract-plugin
export default {"overlayStyle":"styles_overlayStyle__X8gQe","containerStyle":"styles_containerStyle__z+d2j"};